import {ACTIONS} from "./_actions";
import {store, store$, getRules} from "./_config-store";
import {setupInteriorBuilder} from "./_interior-builder";
import {setupExteriorBuilder} from "./_exterior-builder";
import "./vueComponents/vue-keep-scroll";
import "./vueComponents/configuratorMain";
import "./vueComponents/miscOverlay";
import "./vueComponents/dialogOverlay";
import "./vueComponents/optionsTray";
import "./vueComponents/cabTypes";
import "./vueComponents/modalDialog";
import "./vueComponents/modalDetails";
import "./vueComponents/itemCard";
import "./vueComponents/quoteSummary";
import "./vueComponents/requestQuote";
import "./vueComponents/leadSubmit";
import VueMask from './vueComponents/v-mask';

Vue.use(VueMask);
Vue.config.ignoredElements = [
	"mobile-flip", "inner-content", "comp-card-list", "comp-image"
];

window.addEventListener('load', () => {
	new Vue({el: '#configurator-outer'});
	new Vue({el: '[cab-choose-hero]'});

	store.dispatch({
		type: ACTIONS.SET_LOADING,
		data: true
	});

	getRules()
		.then((rules)=>{
			let state = store.getState();
			store.dispatch({
				type: ACTIONS.INIT_CONFIGURATOR
			});
			// init the exterior builder
			setupExteriorBuilder("#exterior-builder", state, null, false, rules);

			// init the interior builder
			setupInteriorBuilder("#interior-builder", state, store, rules);
		})
		.catch(error => {
			store.dispatch({
				type: ACTIONS.INIT_CONFIGURATOR_FAILED,
				error
			});
		});	

});